// src/components/ui/LanguageSwitcher/LanguageSwitcher.jsx
import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const languages = [
  { code: 'en', label: 'EN', flagUrl: '/assets/img/ci/icon/en.png' },
  { code: 'th', label: 'TH', flagUrl: '/assets/img/ci/icon/th.png' },
]

export default function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  // close dropdown on outside click
  useEffect(() => {
    function onClick(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [])

  const current = languages.find(l => l.code === i18n.resolvedLanguage) || languages[0]

  const switchTo = code => {
    i18n.changeLanguage(code)
    localStorage.setItem('i18nextLng', code)
    setOpen(false)
  }

  return (
    <div
      ref={ref}
      style={{ position: 'relative', display: 'inline-block' }}
    >
      <button
        onClick={() => setOpen(o => !o)}
        aria-haspopup="true"
        aria-expanded={open}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          padding: '8px',
          border: '1px solid #ccc',
          borderRadius: 6,
          background: '#F5F5F5',
          cursor: 'pointer',
          height: '39px'
        }}
      >
        <img
          src={current.flagUrl}
          alt={current.label}
          style={{
            height:16,
            objectFit: 'contain',
            display: 'block',
          }}
        />
        <span>{current.label}</span>
      </button>

      {open && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: 4,
            background: '#fff',
            border: '1px solid #ccc',
            borderRadius: 6,
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            zIndex: 1000,
          }}
        >
          {languages.map(lang => (
            <button
              key={lang.code}
              onClick={() => switchTo(lang.code)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                padding: '8px 12px',
                width: '100%',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#f5f5f5'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              <img
                src={lang.flagUrl}
                alt={lang.label}
                style={{
                  width:24,
                  height:16,
                  objectFit: 'contain',
                  display: 'block',
                }}
              />
              <span>{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
